module.exports = __webpack_public_path__ + "img/full3-min.2e1dfd8b.png";